import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { setPreviousRoute, setLastWorkUrl } from "@/lib/lastRoute";
import { record } from "@/lib/journey";

const SERVICE_ROUTES: Record<string, string> = {
  "/system": "The System",
  "/solutions": "Capabilities",
  "/design": "Design",
  "/platform": "Platform",
  "/labs": "codelumenLabs",
  "/about": "About",
};

/**
 * Records the route the user is leaving (so "All Projects" on a project
 * detail page can decide whether to go back or to /work), tracks the
 * most recent /work URL visited in this session for the "return to where
 * I left off" case, and emits journey events for lead intelligence.
 */
export default function RouteHistoryTracker() {
  const location = useLocation();
  const currentRef = useRef<string>(location.pathname + location.search);

  useEffect(() => {
    const next = location.pathname + location.search;
    setPreviousRoute(currentRef.current);
    currentRef.current = next;

    if (location.pathname === "/work") {
      setLastWorkUrl(next);
    }

    const title =
      typeof document !== "undefined" ? document.title.slice(0, 120) : "";
    record("page_view", next, title);

    // Service view — canonical service pages.
    const serviceLabel = SERVICE_ROUTES[location.pathname];
    if (serviceLabel) record("service_view", serviceLabel, location.pathname);

    // Project view — /work/:slug detail pages.
    const projectMatch = location.pathname.match(/^\/work\/([^/]+)$/);
    if (projectMatch) record("project_view", projectMatch[1], location.pathname);
  }, [location.pathname, location.search]);

  return null;
}
